import { COLORS, SHADOWS } from "./designSystem";

// Si decide dall'hostname e non da NODE_ENV perché anche una build di
// produzione servita in locale (docker compose) deve essere riconoscibile:
// il rischio da evitare è scambiare la copia locale per quella in esercizio.
const HOST_LOCALI = ["localhost", "127.0.0.1", "0.0.0.0", "[::1]"];

export default function LocalBadge() {
  if (!HOST_LOCALI.includes(window.location.hostname)) return null;
  // Striscia su tutta la larghezza più linguetta centrale: la striscia si nota
  // anche con la coda dell'occhio, la linguetta dice esplicitamente cosa sia.
  return (
    <div data-testid="local-badge" className="fixed inset-x-0 top-0 z-[9999] pointer-events-none select-none">
      <div className="h-1" style={{ background: COLORS.danger }} />
      <div
        className="absolute left-1/2 top-0 -translate-x-1/2 px-5 py-1.5 rounded-b-lg text-sm font-extrabold uppercase tracking-[0.2em] text-white"
        style={{ background: COLORS.danger, boxShadow: SHADOWS.flottante }}
      >
        ● Local
      </div>
    </div>
  );
}
